export default __webpack_public_path__ + "de1e6ce851de48cc979d1939b2af0206.png";